//------------------------------------------------------------------------------
// Node Modules ----------------------------------------------------------------
import React from 'react';

export const StoreConfigContext = React.createContext({
  featureFlags: {},
  storeConfig: {},
});
